import { render, staticRenderFns } from "./AboutMeSection.vue?vue&type=template&id=98dbe184"
import script from "./AboutMeSection.vue?vue&type=script&lang=js"
export * from "./AboutMeSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports